<template>
    <div class="addMedical">
        <div class="outer-border">
            <div class="set-padding">
                <div class="second-div margin20 border-ddd">
                    <span class="red-color">医案信息</span>
                </div>
                <el-row>
                    <el-col :span="24">
                        <el-row>
                            <div class="wrap-box">
                                <div class="label-name">医案编号：</div>
                                <div class="values valuesLang">{{ form.id }}</div>
                            </div>
                            <div class="wrap-box">
                                <div class="label-name">查看截止时间：</div>
                                <div class="values">永久</div>
                            </div>
                        </el-row>

                    </el-col>
                </el-row>
                <div class="second-div margin20 border-ddd">
                    <span class="red-color">基本信息</span>
                    <el-button class="small-btn fr red-long-btn" @click="editYiAn()">编辑</el-button>
                </div>
                <el-row>
                    <el-col :span="24">
                        <div class="wrap-box">
                            <div class="label-name">姓名：</div>
                            <div class="values">{{ form.name }}</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">性别：</div>
                            <div class="values">{{ form.sex }}</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">教育程度：</div>
                            <div class="values">{{ form.nation }}</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">是否已婚：</div>
                            <div class="values">{{ form.maritalStatus == 1 ? '未婚' : '已婚' }}</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">职业：</div>
                            <div class="values">{{ form.job }}</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">年龄：</div>
                            <div class="values">{{ form.age }}</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">身高：</div>
                            <div class="values">{{ form.height }} cm</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">体重：</div>
                            <div class="values">{{ form.weight }} Kg</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">身份证号：</div>
                            <div class="values">{{ form.cards }}</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">出生日期：</div>
                            <div class="values">{{ form.birthDate }}</div>
                        </div>
                        <div class="wrap-box" v-if="womenSee">
                            <div class="label-name">孕妇：</div>
                            <div class="values">{{ form.isPregnant == 1 ? '否' : '是' }}</div>
                        </div>
                        <div class="wrap-box" v-if="womenSee&&form.isPregnant != 1">
                            <div class="label-name">孕周：</div>
                            <div class="values">{{ form.pregnantWeek }}</div>
                        </div>
                        <div class="wrap-box" v-if="womenSee&&form.isPregnant != 1">
                            <div class="label-name">怀孕时间：</div>
                            <div class="values">{{ getdate(form.pregnancyStartTime1) }}</div>
                        </div>
                        <div class="wrap-box">
                            <div class="label-name">性史：</div>
                            <div class="values">{{ form.sexHistory == 1 ? '无' : '有' }}</div>
                        </div>

                        <div class="wrap-box" v-if="womenSee && form.sexHistory != 1">
                            <div class="label-name" >生育史：</div>
                            <div class="values">{{ form.childbearingHistory }} 个</div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="wrap-box">
                            <div class="label-name">住址：</div>
                            <div class="values2">{{ form.province + ',' + form.city + ',' + form.district + ',' +
                                form.address }}
                            </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="wrap-box">
                            <div class="label-name">个人史：</div>
                            <div class="values2" v-if="GRSList2.length">
                                <span style="margin-right: 6px;" v-for="(item, index) in GRSList2"
                                    :key="index">{{ item.lableTwo }}</span>
                            </div>
                            <div class="values2" v-else>
                                无
                            </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="wrap-box">
                            <div class="label-name">药物过敏史：</div>
                            <div class="values2" v-if="YWGMSList2.length">
                                <span style="margin-right: 6px;" v-for="(item2, index2) in YWGMSList2"
                                    :key="index2">{{ item2.lableTwo }}</span>
                            </div>
                            <div class="values2" v-else>
                                无
                            </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="wrap-box">
                            <div class="label-name">家族史：</div>
                            <div class="values2" v-if="JZSList2.length">
                                <span style="margin-right: 6px;" v-for="(item3, index3) in JZSList2"
                                    :key="index3">{{ item3.lableTwo }}</span>
                            </div>
                            <div class="values2" v-else>
                                无
                            </div>
                        </div>
                    </el-col>
                    <el-col>
                        <div class="wrap-box">
                            <div class="label-name">既往史：</div>
                            <div class="values2" v-if="JWSList2.length">
                                <span style="margin-right: 6px;" v-for="(item4, index4) in JWSList2"
                                    :key="index4">{{ item4.lableTwo }}</span>
                            </div>
                            <div class="values2" v-else>
                                无
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="second-div margin20 border-ddd">
                    <span class="red-color">诊断记录</span>
                    <el-button class="small-btn fr red-long-btn" @click="goDiagnostic()">前往诊断</el-button>
                </div>
                <div class="third">
                    <el-row class="margin20 bg-white border-ddd set-padding" v-for="(item, index) in dangAnDataList"
                        :key="index">
                        <el-col :span="1" style="margin-top:15px">
                            <img :src="require('@/assets/img/nan.png')" alt v-if="item.sex === '男'" />
                            <img :src="require('@/assets/img/nv.png')" alt v-else />
                        </el-col>
                        <el-col :span="23" style="padding-left:10px">
                            <el-row>
                                <el-col :span="24">
                                    <p style="padding-bottom:15px">
                                        <span>{{ item.name }}</span>&nbsp;&nbsp;&nbsp;
                                        <span class="grey-word">{{
                                            limitMaxWords(20, item.disease)
                                            }}</span>
                                        <el-button type="warning" class="small-btn fr"
                                            @click="fuZhen(item)"
                                            v-if="item.diagnoseFlag === 0">复诊</el-button>
                                    </p>
                                </el-col>
                            </el-row>
                            <div class="dotted-line1"></div>
                            <el-row>
                                <el-col :span="24">
                                    <p>
                                        <span class="fl">
                                            {{ toChinesNum(item.unmber) }}诊时：
                                            <span v-if="item.gfList.length">《
                                                <template v-for="(cur, i) in item.gfList">
                                                    {{ cur.rectificationName }} <i
                                                        v-if="i != item.gfList.length - 1">,</i>
                                                </template>
                                                》</span>
                                        </span>
                                        <span class="fr grey-word">{{ item.appVisitTime }}</span>
                                    </p>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <p>
                                        <span class="grey-word text-justity">{{
                                            limitMaxWords(50, item.fangGe)
                                            }}</span>
                                        <span class="red-color-font shou" @click="viewDetail(item.id, item.medId)">
                                            查看详情
                                            <i class="el-icon-d-arrow-right"></i>
                                        </span>
                                    </p>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <div class="noList" v-if="!dangAnDataList.length">
                        <img src="@/assets/img/quesheng2.png" alt="" srcset="">
                    </div>
                    <el-row :class="isDisplay ? 'displayNone' : ''">
                        <el-col>
                            <el-pagination background layout="prev, pager, next" :total="dangAnPage.total"
                                :page-size="dangAnPage.pageSize" :current-page.sync="dangAnPage.pageNum"
                                @current-change="handleCurrentChange"></el-pagination>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "@/assets/style/addMedical.css"; //引入公共样式
import rules from "@/common/rules";

export default {
    name: "addMedical",
    data() {
        return {
            dangAnDataList: [], //档案数据
            dangAnPage: {
                pageNum: 1,
                pageSize: 6,
                total: 0
            },
            isDisplay: false,
            JWSList2:[],
            YWGMSList2:[],
            JZSList2:[],
            GRSList2: [],
            form: {
                selectedOptions: [],
                id: "",
                userId: "",
                name: "",
                cards: "",
                birthDate: "",
                age: "",
                nation: "",
                maritalStatus: "",
                sexHistory: "",
                province: "",
                city: "",
                district: "",
                address: "",
                educational: "",
                job: "",
                weight: "",
                height: "",
                sys: "",
                childbearingHistory: "",
                isPregnant: "",
                pregnancyStartTime1: null,
                pregnancyStartTime: null,
                pregnantWeek: "",
                grs: null, // 个人史
                jws: null, // 既往史
                jzs: null, // 家族史
                ywgms: null, // 药物过敏史
            },
            womenSee: false, //只有性别为女的才能看见
            shengyuShow: false, //生育史有的话，才显示生育数量
            pregnant: false //是孕妇，才能看见
        };
    },
    methods: {
        //前往诊断
        goDiagnostic() {
            let that = this;
            if (that.$route.query.id) {
                that.$router.push({
                    path: "/diagnosis",
                    query: { id: that.$route.query.id }
                });
            }
        },
        //复诊
        fuZhen(item) {
            this.$router.push({
                path: "/diagnosis",
                query: { 
                    id: item.medId,
                     firstArchivesId:item.firstArchivesId?item.firstArchivesId:item.id
                    }
            });
        },
         //编辑医案
            editYiAn() {
                let that = this; 
            this.$router.push({
                path: "/addMedical",
                query: { id: that.$route.query.id  }
            });
            },
        //档案选页
        handleCurrentChange(v) {
            let that = this;
            that.dangAnPage.pageNum = v; //当前页
            that.dangAnList(that.selectYaId);
        },
        //档案列表
        dangAnList(id) {
            let that = this;
            let userInfo = null;
            if (sessionStorage.getItem("userInfo")) {
                userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            }
            let params = {
                id: id,
                name: null,
                firstTime: null,
                pageNum: that.dangAnPage.pageNum,
                pageSize: that.dangAnPage.pageSize,
                userId: userInfo.id,
            };
            let url = "medicalCasesPc/getArchivesByMedId";
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        console.log(res.data, 'res.data')
                        that.dangAnDataList = res.data.list;
                        if (that.dangAnDataList.length > 0) {
                            that.isDisplay = false;
                        } else {
                            that.isDisplay = true;
                        }
                        that.dangAnPage.total = res.data.total;
                        that.dangAnPage.pageSize = res.data.pageSize;
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        },
        //查看档案详情
        viewDetail(id, medId) {
            this.$router.push({
                path: "/recResults",
                query: { id: id, medId: medId, name: "1" }
            });
        },

        // 去重方法
        unique(arr) {
            for (var i = 0; i < arr.length; i++) {
                for (var j = i + 1; j < arr.length;) {
                    if (arr[i].lableTwo === arr[j].lableTwo) {
                        arr.splice(j, 1)
                    } else {
                        j++
                    }
                }
            }
            return arr
        },
        //获取医案详情
        infoDisplay(id) {
            let that = this;
            let params = {
                id: id
            };
            let url = "medicalCasesPc/getYaById";
            that.$http
                .post(url, params)
                .then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        that.form = res.data;
                        // 个人史回显
                        // this.GRSList = [];
                        this.GRSList2 = [];
                        for (const item of res.data.personageHistorys) {
                            that.GRSList2.push({
                                check: true,
                                id: item.id,
                                lableTwo: item.personalHistory,
                                selectYears: String(that.yearsCal(item.years))
                            });
                        }
                        // that.GRSList2.push({
                        //     check: false,
                        //     id: "",
                        //     lableTwo: "",
                        //     custom: true
                        // });
                        let temporaryArry = []
                        let newArr = that.GRSList2.concat(that.GRSList)
                        let currentIdx = newArr.findIndex(v => v.lableTwo == "");
                        temporaryArry.push(newArr[currentIdx]);
                        newArr.splice(currentIdx, 1)
                        newArr = newArr.concat(temporaryArry);
                        that.GRSList = that.unique(newArr)
                        // 既往史回显
                        // this.JWSList = [];
                        this.JWSList2 = [];
                        for (const item of res.data.previousHistorys) {
                            that.JWSList2.push({
                                check: true,
                                id: item.id,
                                lableTwo: item.previousHistory,
                                startDate: item.startDate
                            });
                        }
                        // this.JWSList2.push({
                        //     check: false,
                        //     id: "",
                        //     lableTwo: "",
                        //     custom: true
                        // });
                        let JWSList2Arr = []
                        let JWSNewArr = that.JWSList2.concat(that.JWSList)
                        let JWScurrentIdx = JWSNewArr.findIndex(v => v.lableTwo == "");
                        JWSList2Arr.push(JWSNewArr[JWScurrentIdx]);
                        JWSNewArr.splice(JWScurrentIdx, 1)
                        JWSNewArr = JWSNewArr.concat(JWSList2Arr);
                        that.JWSList = that.unique(JWSNewArr)
                        // 家族史回显
                        // this.JZSList = [];
                        this.JZSList2 = [];
                        for (const item of res.data.familyHistory) {
                            that.JZSList2.push({
                                check: true,
                                id: item.id,
                                lableTwo: item.illness,
                                familyMember: item.familyMember
                            });
                        }
                        // this.JZSList2.push({
                        //     check: false,
                        //     id: "",
                        //     lableTwo: "",
                        //     custom: true
                        // });
                        let JZSList2Arr = []
                        let JZSNewArr = that.JZSList2.concat(that.JZSList)
                        let JZScurrentIdx = JZSNewArr.findIndex(v => v.lableTwo == "");
                        JWSList2Arr.push(JZSNewArr[JZScurrentIdx]);
                        JZSNewArr.splice(JZScurrentIdx, 1)
                        JZSNewArr = JZSNewArr.concat(JZSList2Arr);
                        that.JZSList = that.unique(JZSNewArr)
                        // 药物过敏史回显
                        // this.YWGMSList = [];
                        this.YWGMSList2 = [];
                        for (const item of res.data.medicineIrritabilityHistory) {
                            that.YWGMSList2.push({
                                check: true,
                                id: item.id,
                                lableTwo: item.medicine
                            });
                        }
                        // this.YWGMSList2.push({
                        //     check: false,
                        //     id: "",
                        //     lableTwo: "",
                        //     custom: true
                        // });
                        let YWGMSList2 = []
                        let YWGMSNewArr = that.YWGMSList2.concat(that.YWGMSList);
                        let YWGMScurrentIdx = YWGMSNewArr.findIndex(v => v.lableTwo == "");
                        JWSList2Arr.push(YWGMSNewArr[YWGMScurrentIdx]);
                        YWGMSNewArr.splice(YWGMScurrentIdx, 1)
                        YWGMSNewArr = YWGMSNewArr.concat(YWGMSList2);
                        that.YWGMSList = that.unique(YWGMSNewArr)
                        if (res.data.sex == "女") {
                            that.womenSee = true;
                        }
                        if (res.data.childbearingHistory) {
                            that.shengyuShow = true;
                            that.form.sys = "0";
                        }
                        // 根据怀孕时间计算孕周
                        if (res.data.pregnancyStartTime) {
                            that.pregnant = true;
                            that.form.pregnancyStartTime1 = that.changeChuo(
                                res.data.pregnancyStartTime
                            );
                            let timestamp2 = new Date().valueOf();
                            that.form.pregnantWeek = parseInt(
                                (timestamp2 - that.form.pregnancyStartTime1) / 604800000
                            );
                        }
                        // 省市区回显
                        if (res.data.ssqBmStr) {
                            let aaa = res.data.ssqBmStr.split(",");
                            that.form.selectedOptions = [aaa[0], aaa[1], aaa[2]];
                        }
                    } else {
                        that.$message.error(res.msg);
                    }
                })
                .catch(() => {
                });
        }
    },
    created() {
        let that = this;
        if (!!that.$route.query.id) {
            //编辑
            that.form.id = that.$route.query.id;
            that.infoDisplay(that.$route.query.id);
            that.dangAnList(that.$route.query.id);
        }
    }
};
</script>

<style scoped>
.displayNone {
    display: none;
}

.addMedical .el-input-group__append {
    padding: 0px 2px !important;
}

.shenti .el-form-item__content .el-input-group {
    vertical-align: middle;
}

.iconOut {}

.wrap-box {
    float: left;
    margin-right: 20px;
    margin-top: 10px;
    display: flex;
    align-items: center;
}

.label-name {
    width: 100px;
    text-align: right;
}

.wrap-box .values {
    width: 131px;
    color: #666;
}

.wrap-box .values2 {
    color: #666;
}

.wrap-box .valuesLang {
    width: 180px;
}

.second-div {
    background-color: #fff;
    padding: 13px 20px;
    margin-top: 20px;
}

.second-div:nth-of-type(1) {
    margin-top: 0px;
}

.red-color {
    color: #f64420;
    border-bottom: 3px solid #f64420;
    padding-bottom: 14px;
}

.red-border {
    border: solid 1px #f64420;
}

.el-form-item {
    margin-bottom: 10px;
}

.noList {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.noList img {
    width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/JW/diagnosticDetails.vue